// extracted by mini-css-extract-plugin
export var animateProgress = "Accordion-module--animateProgress--75476";
export var content = "Accordion-module--content--27157";
export var copy = "Accordion-module--copy--93238";
export var copyWrapper = "Accordion-module--copy-wrapper--38489";
export var grid = "Accordion-module--grid--c8b9e";
export var image = "Accordion-module--image--9f31e";
export var imageWrapper = "Accordion-module--image-wrapper--1ecc9";
export var progressBar = "Accordion-module--progress-bar--a84fe";
export var section = "Accordion-module--section--5102f";